import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/axios'
require('./mock/index')

import 'vant/lib/index.css';

import {
    Button,NoticeBar , Form, Field, CellGroup, Toast, Tabbar, TabbarItem, Swipe, SwipeItem, Col, Row, ImagePreview, List, Tab, Tabs, Search, Image as VanImage, ConfigProvider, TextEllipsis,Highlight,
    ActionBar, ActionBarIcon, ActionBarButton, Empty, Cell, DropdownMenu, DropdownItem, Collapse, CollapseItem, Icon, Sidebar, SidebarItem, Overlay, Popup, Sticky, NavBar, BackTop
} from 'vant'

// import MarkdownIt from "markdown-it";



const app = createApp(App)
//全局配置
app.config.globalProperties.$axios = axios;

// app.use(MarkdownIt);
app.use(Button);
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(Toast);
app.use(Tabbar);
app.use(TabbarItem);
app.use(Swipe);
app.use(SwipeItem);
app.use(ActionBar);
app.use(ActionBarIcon);
app.use(ActionBarButton);
app.use(Empty);
app.use(Cell);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Collapse);
app.use(CollapseItem);
app.use(Icon);
app.use(Sidebar);
app.use(SidebarItem);
app.use(Overlay);
app.use(Popup);
app.use(store);
app.use(router);
app.use(Sticky);
app.use(NavBar);
app.use(Col);
app.use(Row);
app.use(BackTop);
app.use(ImagePreview);
app.use(List);
app.use(Tab);
app.use(Tabs);
app.use(Search);
app.use(VanImage);
app.use(ConfigProvider);
app.use(TextEllipsis);
app.use(Highlight);
app.use(NoticeBar);

app.mount('#app')
